import request from '@/utils/request'

export function visit(data) {
  return request({
    url: '/mail/visit',
    method: 'post',
    data
  })
}

export function get(page) {
  return request({
    url: '/mail',
    method: 'get',
    params: { page }
  })
}

